import emailService from '../services/emailService';

export async function sendReportEmail(emailData, { event_id } = {}) {
  const payload = {
    to: emailData.to,
    cc: emailData.cc || '',
    bcc: emailData.bcc || '',
    subject: emailData.subject,
    text: emailData.content,
    html: `<pre style="font-family: Arial, sans-serif; white-space: pre-wrap;">${String(emailData.content || '').replace(/</g, '&lt;')}</pre>`,
    event_id
  };

  return emailService.sendCustomNotification(payload, emailData.attachments || []);
}
